  // Custom debounce function in TypeScript
  export function debounce<T extends (...args: any[]) => void>(
    func: T,
    delay: number
  ): (...args: Parameters<T>) => void {
    let timeout: ReturnType<typeof setTimeout>; // Correct type for `setTimeout` return
    return (...args: Parameters<T>) => {
      clearTimeout(timeout); // Clears the timeout if the function is called again
      timeout = setTimeout(() => func(...args), delay); // Sets the new timeout
    };
  }